import { RefundsBuildingsRequestInterface } from '../../../interfaces/request/refunds-buildings/refunds-buildings-request-interface';

export class CpRefundsBuildingsRequestModel implements RefundsBuildingsRequestInterface {
  practiceNif: string = '';
  practiceNifCode: string = '';

  constructor(init?: Partial<CpRefundsBuildingsRequestModel>) {
    Object.assign(this, init);
  }
}
